import React from 'react';
import { ContentList, ContentListItem } from '../../_lib/components/ContentList';
import ILink from '../../types/ILink';
import { PageTypeDescription, PageTypeIcon } from '../../_lib/components/PageType';
import Hyperlink from '../../components/atoms/Hyperlink/Hyperlink';
import { PageType } from '../../types/api/PageType';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { translatePageType } from '../../_lib/components/PageType/PageTypeTitle';
import { PageTypeIconModifiers } from '../../_lib/components/PageType/PageTypeIcon';

type PageTypeListItem = {
  name: PageType;
  editLink: ILink;
};

type PageTypeListItemWithTitle = PageTypeListItem & { title: string };

export type PageTypesListProps = {
  pageTypes: PageTypeListItem[];
};

/**
 * Linked list of all page types with icons and description.
 *
 * - sorting is done alphabetically with the translated keys for now until backend is done with the orderKeys.
 */
function PageTypesList({ pageTypes }: PageTypesListProps) {
  if (pageTypes?.length === 0) {
    return null;
  }

  const sortByName = (a: PageTypeListItemWithTitle, b: PageTypeListItemWithTitle) => (a.title > b.title ? 1 : -1);

  const pageTypesWithTranslatedName = pageTypes.map(pageType => ({
    ...pageType,
    title: translatePageType(pageType.name),
  })) as PageTypeListItemWithTitle[];

  return (
    <ContentList ordered>
      {pageTypesWithTranslatedName.sort(sortByName).map(pageTypeItem => {
        return (
          <ContentListItem key={pageTypeItem.name}>
            <div className="page-types-list__container">
              <PageTypeIcon
                pageType={pageTypeItem.name}
                modifier={[PageTypeIconModifiers.LARGE_ROUNDED, PageTypeIconModifiers.ALIGN_SELF_TOP]}
              />
              <p className="page-types-list__label-text-container">
                <span className="page-types-list__link-container">
                  <Hyperlink to={pageTypeItem.editLink.url} className="page-types-list__page-type font-bold-18-18">
                    {pageTypeItem.title}
                  </Hyperlink>
                </span>
                <span className="page-types-list__page-description font-regular-16-18">
                  <PageTypeDescription pageType={pageTypeItem.name} />
                </span>
              </p>
            </div>
          </ContentListItem>
        );
      })}
    </ContentList>
  );
}

export const PageTypesListBlock = asBlock(PageTypesList, BlockType.pagetypeslist);
